import { makeAutoObservable, runInAction } from "mobx";
import store from "./store";
import { mutate } from "swr";

export default class InterviewStore {
  constructor() {
    makeAutoObservable(this);
  }

  loading = false;
  error = false;

  getStatusByInterviewType = (interviewType) => {
    switch (interviewType) {
      case "InitialInterview":
        return "InitialInterview";
      case "FinalInterview":
        return "FinalInterview";
      default:
        return "Scheduled";
    }
  };

  handleFinalSubmit = async (values, apiFunction, userId) => {
    runInAction(() => {
      this.loading = true;
      this.error = false;
    });

    try {
      const payload = {
        applicantId: values.applicantId,
        jobOpeningId: values.jobOpeningId,
        interviewerId: userId,
        type: values.type,
        status: values.status,
        scheduledDate: values.scheduledDate,
        startTime: values.startTime.format("HH:mm:ss"),
        endTime: values.endTime.format("HH:mm:ss"),
        onSiteLocation: values.onSiteLocation,
        onlineLink: values.onlineLink,
        notes: values.notes,
      };

      await apiFunction.create(payload);

      if (values.type === "InitialInterview" || values.type === "FinalInterview") {
        const newStatus = this.getStatusByInterviewType(values.type);

        await store.offerLetterStore.handleUpdateApplicationStatus(values.applicantId, newStatus);
      }

      mutate((key) => typeof key === "string" && key.includes("/system-admin/interview"), undefined, { revalidate: true });

      store.notificationStore.showNotification("Check the latest schedule updates", "success", {
        title: `The interview has been saved`,
        duration: 5000,
      });

      return true;
    } catch (error) {
      runInAction(() => {
        this.error = true;
      });
      const errorMessage = error.response?.data?.message || "Failed to save interview";
      store.notificationStore.showNotification(errorMessage, "error", { title: "Error" });
      return false;
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };
}
